/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { apiGet, apiPost } from "./Api/apiCall";
import { PaidTaskReviewDecision, PaidTaskReviewResponse, PaidTaskReviewResolution, PaidTaskReviewState } from "../types/PaidTaskReview";

export const paidTaskReviewQueryKey = (paidTaskId: number) => ["paidTaskReviews", paidTaskId];

export function getPaidTaskReviews(paidTaskId: number): Promise<PaidTaskReviewState> {
  return apiGet<PaidTaskReviewState>(`paid_tasks/${paidTaskId}/document_reviews`);
}

export function reviewPaidTask(paidTaskId: number): Promise<PaidTaskReviewState> {
  return apiPost<PaidTaskReviewState>(`paid_tasks/${paidTaskId}/document_review`);
}

export function respondToPaidTaskReview(
  paidTaskId: number, reviewId: number,
  response: { statements: PaidTaskReviewResponse[] } | { decisions: PaidTaskReviewDecision[]; resolution: PaidTaskReviewResolution },
): Promise<PaidTaskReviewState> {
  const action = "decisions" in response ? "decision" : "challenge";
  return apiPost<PaidTaskReviewState>(`paid_tasks/${paidTaskId}/document_reviews/${reviewId}/${action}`, response);
}
